import { generatePath } from "react-router-dom";

import { PublicReport, Report } from "@/types/Report";

import fetcher_v2 from "../fetcher_v2";
import { URLS } from "../urls";
import { ReportSubscriptionInterval, ReportTemplateType } from "@/constants";

export const createReport = (data: {
  template: ReportTemplateType;
  alert_sources: Uuid[];
  tag_sources: Uuid[];
  interval?: ReportSubscriptionInterval;
}) => {
  return fetcher_v2<Report>(URLS.REPORT_LIST, {
    method: "POST",
    body: data,
  });
};

export const deleteReport = (uuid: string) =>
  fetcher_v2(generatePath(URLS.REPORT, { uuid }), {
    method: "DELETE",
  });

export const getPublicReport = (uuid: string) => {
  return fetcher_v2<PublicReport>(URLS.PUBLIC_SEARCH, {
    method: "GET",
    body: { search_id: uuid },
  });
};
